export const PrivacySection2 = () => {
  return (
    <section>
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Facebook Platform Data Usage</h2>
      <div className="space-y-4 text-base leading-relaxed text-gray-700">
        <p className="font-semibold text-gray-900">
          When you connect your Facebook, Instagram, or WhatsApp Business accounts to WinGrow, we
          access and process data from these platforms in accordance with Facebook Platform Terms
          and WhatsApp Business API Terms.
        </p>

        <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
          3.1 Data We Access from Facebook/Instagram/WhatsApp
        </h3>
        <ul className="ml-6 space-y-2 list-disc">
          <li>
            <strong>Profile Information:</strong> Your name, email address, and profile picture from
            your Facebook account
          </li>
          <li>
            <strong>Page Access Tokens:</strong> Credentials to access your Facebook Pages and
            Instagram Business accounts
          </li>
          <li>
            <strong>WhatsApp Business Account Data:</strong> Business phone number, account status,
            and configuration
          </li>
          <li>
            <strong>Messenger Conversations:</strong> Messages sent to and from your Facebook Page
          </li>
          <li>
            <strong>Instagram Messages:</strong> Direct messages sent to and from your Instagram
            Business account
          </li>
          <li>
            <strong>WhatsApp Messages:</strong> Messages sent to and from your WhatsApp Business
            account
          </li>
          <li>
            <strong>Page Analytics and Insights:</strong> Performance metrics, engagement data, and
            audience demographics
          </li>
          <li>
            <strong>Lead Information:</strong> Contact information of people who message your
            business through these platforms
          </li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
          3.2 How We Use Facebook Platform Data
        </h3>
        <ul className="ml-6 space-y-2 list-disc">
          <li>
            <strong>Lead Management:</strong> Organize and track conversations with potential
            customers across platforms
          </li>
          <li>
            <strong>Automated Responses:</strong> Use AI to generate appropriate responses to
            customer inquiries
          </li>
          <li>
            <strong>Conversation Analytics:</strong> Analyze conversation patterns to improve
            customer engagement
          </li>
          <li>
            <strong>Performance Insights:</strong> Provide you with analytics about your messaging
            performance
          </li>
          <li>
            <strong>Contact Organization:</strong> Store and organize lead contact information for
            follow-up
          </li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
          3.3 Data Retention from Facebook Platforms
        </h3>
        <p>
          We retain conversation data and lead information for as long as your account is active or
          as needed to provide you services. Message data is automatically deleted after 30 days
          unless you choose to retain it for longer periods. You can request deletion of your data
          at any time (see Section 4 below).
        </p>

        <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
          3.4 Compliance with Facebook Platform Terms
        </h3>
        <p>WinGrow operates in strict compliance with:</p>
        <ul className="ml-6 space-y-2 list-disc">
          <li>
            <strong>Facebook Platform Terms:</strong>{' '}
            <a
              href="https://developers.facebook.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              https://developers.facebook.com/terms
            </a>
          </li>
          <li>
            <strong>WhatsApp Business API Terms:</strong>{' '}
            <a
              href="https://www.whatsapp.com/legal/business-terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              https://www.whatsapp.com/legal/business-terms
            </a>
          </li>
          <li>
            <strong>Instagram Platform Policy:</strong>{' '}
            <a
              href="https://www.instagram.com/about/legal/terms/api"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              https://www.instagram.com/about/legal/terms/api
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
};
